import { useRef, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import axios from 'axios';
import { requestWithAuth } from '../../services/api';

interface RequestParams {
  lookup_type: string;
  search_key: string;
  search_value: string;
  filter_type: string;
}

const CreatableMultiSelect = ({
  id,
  isMulti,
  placeholder,
  isClearable = true,
  onSelect,
  value,
}) => {
  const [options, setOptions] = useState([]);
  const sourceRef = useRef<
    { cancel: (message?: string) => void; token: unknown } | undefined
  >(undefined);

  function handleInputChange(value) {
    const options = [];
    if (value.length > 0) {
      if (sourceRef.current)
        sourceRef.current.cancel('Operation canceled by the user.');
      const { CancelToken } = axios; // eslint-disable-line import-x/no-named-as-default-member
      sourceRef.current = CancelToken.source();
      const params: RequestParams = {
        lookup_type: 'n2',
        search_key:
          id === 'org_name' ? 'ai_org' : id === 'exc_title' ? 'title' : id,
        search_value: value,
        filter_type: 'all',
      };

      requestWithAuth(
        'auto-suggest-new',
        'GET',
        params,
        null,
        sourceRef.current.token,
      )
        .then((response) => {
          if (response && response.result) {
            response.result.map((data) => {
              if (data)
                switch (id) {
                  case 'org_name':
                    options.push({
                      value: data.ai_org_id,
                      label: data.name
                        ? data.name.toString().toTitleCase()
                        : '',
                      labelValue: data.name,
                    });
                    break;
                  default:
                    options.push({
                      value: data,
                      label: data.toString().toTitleCase(),
                    });
                    break;
                }
              return '';
            });
          }
          setOptions(options);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  function debounce(func, delay) {
    let debounceTimer;
    return (...args) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func(...args), delay);
    };
  }

  function handleChange(selected) {
    if (onSelect) {
      onSelect(selected);
    }
  }

  return (
    <CreatableSelect
      formatCreateLabel={(inputValue) => `Contains "${inputValue}"`}
      isValidNewOption={(inputValue) => {
        if (inputValue && inputValue !== '') return true;
      }}
      placeholder={placeholder}
      value={value}
      isMulti={isMulti}
      className="multi-auto-suggest"
      classNamePrefix="ai"
      isSearchable
      isClearable={isClearable}
      hideSelectedOptions={true} // FIX: issue with 2 compnies with same id on selected gets both cleared
      closeMenuOnSelect={false}
      closeMenuOnScroll
      // onFocus={this.inFocus}
      onChange={handleChange}
      // eslint-disable-next-line react-hooks/refs -- sourceRef.current is accessed inside the debounced callback, not during render
      onInputChange={debounce(handleInputChange, 500)}
      options={options}
      autoFocus
      onBlur={() => {
        setOptions([]);
      }}
      createOptionPosition="first"
      noOptionsMessage={() => null}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
    />
  );
};
export default CreatableMultiSelect;
